import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import ToggleButton from "./ToggleButton";

class ToggleButtonGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeButton: 1
    };
  }

  handleClick = (index, cb) => {
    let activeButton = (typeof index === "number" ? index : parseInt(index));
    this.setState({activeButton});
    cb();
  };

  isButtonActive = (index) => {
    return this.state.activeButton === index;
  };

  getButtonsFromProps = () => {
    let buttons = [];

    let {buttonDetailsList} = this.props;
    if(Array.isArray(buttonDetailsList)) {
      let length = buttonDetailsList.length;
      buttonDetailsList.forEach((buttonDetail, i) => {
        if(typeof buttonDetail === "object") {
          buttons.push(
            <ToggleButton key={i} action={() => this.handleClick(i, buttonDetail.action)}
                          active={this.isButtonActive(i)} small={true} iconType={buttonDetail.icon}
            additionalStyles={i !== length -1 ? {marginRight:'none'}: null}/>
          )
        }
      });
    }
    return buttons;
  };

  getClassNames = () => {
    let classNames = "btn-group";
    if(Array.isArray(this.props.additionalClasses)) {
      this.props.additionalClasses.forEach((className) => {
        classNames += ` ${className}`;
      });
    }
    return classNames;
  };

  render() {
    let Buttons = this.getButtonsFromProps;
    let classNames = this.getClassNames();
    return (
      <div className={classNames}>
        <Buttons />
        {/*<ToggleButton iconType="dehaze" small={true} additionalStyles={smallIconStyles}*/}
                      {/*action={this.props.button1Action} active={this.state.button1Active}/>*/}
        {/*<ToggleButton iconType="view_day" small={true} additionalStyles={smallIconStyles}*/}
                      {/*action={this.toggleActiveButton} active={this.state.button2Active}/>*/}
      </div>
    );
  }
}

ToggleButtonGroup.propTypes = {
  buttonDetailsList: PropTypes.array.isRequired,
  isSmall: PropTypes.bool,
  additionalClasses: PropTypes.array
};

class ButtonDetails {
  icon;
  action;

  constructor(icon, action) {
    this.icon = icon;
    this.action = action;
  }
}

export {
  ToggleButtonGroup,
  ButtonDetails
};
